import PropTypes from 'prop-types';
import { useContext, useEffect } from 'react';
import { Layout } from 'antd-v3';
import { combineClassNames } from '@arkestro/arkestro-design-system';

import { LayoutContext } from '@providers/LayoutProvider/LayoutProvider';
import IntercomService from '@services/IntercomService';
import { UserContext } from '@components/providers/UserProvider/UserProvider';
import ErrorBoundary from '@components/shared/ErrorBoundaries/ErrorBoundary';
import Header from '@components/layout/Header/Header';

import style from './Content.module.scss';

const Content = ({ children }) => {
  const user = useContext(UserContext);
  const { collapsed } = useContext(LayoutContext);
  const sidebar = collapsed ? style.sidebarCollapsed : style.sidebarExpanded;
  const contentBodyClassName = combineClassNames(style.container, sidebar);

  // Dependency on Business Region so that if it changes, we reconfigure Intercom
  // the correct region.
  useEffect(() => {
    if (!user.id) return;
    IntercomService.configureUser({ collapsed, currentUser: user });
  },[user.id, user.business_region]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Layout className={collapsed ? 'collapsed' : ''}>
      <Header />
      <Layout.Content>
        <ErrorBoundary>
          <div className={contentBodyClassName} data-testid='content-body' id='content-body'>
            {children}
          </div>
        </ErrorBoundary>
      </Layout.Content>
    </Layout>
  );
};

Content.propTypes = {
  children: PropTypes.node.isRequired
};

export default Content;
